import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Seo } from "@/components/Seo";
import { FAQAccordion } from "@/components/FAQAccordion";
import { BANTUAN_FAQ } from "@/data/faq";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

const RELATED = [
  { label: "Cara Beli", to: "/cara-beli" },
  { label: "Ketentuan Layanan", to: "/ketentuan" },
  { label: "Kebijakan Privasi", to: "/privasi" },
  { label: "Ketentuan Garansi", to: "/garansi" },
];

export default function BantuanPage() {
  const waUrl = buildStockWhatsAppUrl();
  return (
    <>
      <Seo
        title="Bantuan & FAQ"
        description="Pusat bantuan Nofina Movie. Jawaban seputar pemesanan, ketersediaan, harga, penggunaan akun, pembatalan, dan garansi."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="max-w-2xl">
          <h1 className="text-3xl font-extrabold text-nm-text sm:text-4xl">
            Bantuan &amp; FAQ
          </h1>
          <p className="mt-2 text-nm-muted">
            Jawaban untuk pertanyaan yang sering diajukan. Butuh bantuan lain?
            Hubungi kami lewat WhatsApp.
          </p>
        </header>

        <div className="mt-8">
          <FAQAccordion items={BANTUAN_FAQ} testIdPrefix="bantuan-faq" />
        </div>

        <div className="mt-8 rounded-2xl border border-nm-border bg-nm-surface p-6">
          <h2 className="text-sm font-bold text-nm-text">Informasi terkait</h2>
          <div className="mt-3 flex flex-wrap gap-2">
            {RELATED.map((r) => (
              <Link
                key={r.to}
                to={r.to}
                data-testid={`bantuan-link-${r.to}`}
                className="inline-flex h-9 items-center rounded-full border border-nm-border bg-nm-bg2 px-4 text-sm font-semibold text-nm-text transition-colors hover:border-nm-red/40"
              >
                {r.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-nm-border bg-nm-surface p-6 text-center">
          <h2 className="text-lg font-bold text-nm-text">
            Tidak menemukan jawabanmu?
          </h2>
          <p className="mt-1 text-sm text-nm-muted">
            Kirim pertanyaanmu langsung ke tim Nofina Movie.
          </p>
          <div className="mx-auto mt-5 max-w-sm">
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="bantuan-whatsapp"
              className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-wa font-semibold text-white hover:bg-wa-hover"
            >
              <MessageCircle className="h-4 w-4" />
              Cek Stok via WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
